import React, {Component} from 'react';
import LocalizedStrings from '../localization/strings';

export default class TimeTicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            secondsRemaining: 0
        };
    }

    setRemainingTime() {
        const now = new Date();
        this.setState({
            timeRemaining: this.props.date.getTime() - now.getTime()
        });
    }

    tick() {
        this.setRemainingTime();
        if (this.state.timeRemaining <= 0) {
            clearInterval(this.interval);
        }
    }

    getTimeFormatted(ms) {
        if (!ms) {
            return {};
        }
        const pad = (n) => {
            return n < 10
                ? '0' + n
                : n;
        };
        const days = Math.floor(ms / (24 * 60 * 60 * 1000));
        const daysms = ms % (24 * 60 * 60 * 1000);
        const hours = Math.floor((daysms) / (60 * 60 * 1000));
        const hoursms = ms % (60 * 60 * 1000);
        const minutes = Math.floor((hoursms) / (60 * 1000));
        const minutesms = ms % (60 * 1000);
        const sec = Math.floor((minutesms) / (1000));
        return {days: days, hours: pad(hours), minutes: pad(minutes), seconds: pad(sec)}

    }

    componentDidMount() {
        this.setRemainingTime();

        this.interval = setInterval(this.tick.bind(this), 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {

        if (this.state.timeRemaining <= 0) {
            return (
                <div>{LocalizedStrings.eventHasEnded}</div>
            )
        }
        const dateDisplay = this.getTimeFormatted(this.state.timeRemaining);
        return (
            <span>  {LocalizedStrings.timeLeft}:   <br/>&nbsp; {dateDisplay.days}&nbsp;d. {dateDisplay.hours}:{dateDisplay.minutes}:{dateDisplay.seconds}</span>
        )
    }
}



// WEBPACK FOOTER //
// ./src/js/components/time-ticker.js